import React, { useEffect } from 'react';
// import Head from 'next/head';

import Grid from '@material-ui/core/Grid';

import security from '../assets/images/network/security.gif';
import virtual from '../assets/images/network/virtual.gif';
import backup from '../assets/images/network/backup.gif';

import FullRow from './ui/blocks/FullRow';
import TwoInRow from './ui/blocks/TwoInRow';
import LineBreak from './ui/blocks/LineBreak';

export default function Network(props) {
    const content = props.content.network;
    const language = props.language;
    const setValue = props.setValue;
    const setSelectedIndex = props.setSelectedIndex;

    useEffect(() => {
        window.scrollTo(0, 0);
        setValue(1);
        setSelectedIndex(0);
    }, [setValue, setSelectedIndex]);

    return (
        <React.Fragment>
            {/* <Head>
                <title key="title">شبکه عصر دانش آرا</title>
                <meta name="description" key="description" content="شرکت شبکه عصر دانش آرا، ارائه دهنده خدمات اکتیو و پسیو شبکه و کامپیوتر" />
                <meta property="og:title" key="og:title" content="شرکت شبکه عصر دانش آرا، ارائه دهنده خدمات اکتیو و پسیو شبکه و کامپیوتر" />
            </Head> */}

            <Grid container direction="column" dir={language === "per" ? "rtl" : null} style={{ marginTop: "-5em" }}>

                {/* Header /////////////// */}
                <FullRow content={content.header} image={security} language={language} dir={0} imageW={500} />

                {/* Tips */}
                {/* <ThreeInRow content={content.tips} image1={uc} image2={uc} image3={uc} language={language} imageW1={275} imageW2={275} imageW3={310} /> */}
                <LineBreak height="75px" type={0} />

                {/* First row */}
                <FullRow content={content.firstRow} image={virtual} language={language} dir={0} imageW={450} />
                <LineBreak height="75px" type={1} />

                {/* Second row */}
                {/* <FullRowMiddle content={content.secondRow} image={uc} language={language} imageW={450} /> */}
                {/* <LineBreak height="75px" type={0} /> */}

                {/* Third row */}
                <TwoInRow content={content.thirdRow} image={backup} language={language} imageW={350} />

            </Grid >
        </React.Fragment>
    )
}